import React, { useState, useEffect } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";

import { data as newData } from "./../newData";
import axios from "axios";
import { Box, Button, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@material-ui/core";

const mapFilterByKey = {
  "Total": "total_variations",
  "Passed": "passed",
  "Failed": "failed",
  "Reporting Error": "error"
};

const filterData = (data, filter, isFctw) => {
  if (filter === "total_variations") return data;

  return data.filter((item) => {
    if (isFctw) {
      return item.summary.mandatory_target[filter] !== 0;
    } else {
      return (
        item.summary.mandatory_target[filter] !== 0 ||
        item.summary.development_target[filter] !== 0
      );
    }
  });
};

const ScenarioOverview = ({
  selectedExecution,
  onRowClicked,
  scenarioOverviewDetails,
  handleClickForVariation,
  page,
  isFctw,
  scrollingFilter
}) => {
  const [selectedValue, setSelectedValue] = useState(scrollingFilter);
  const [scenarioDetails, setScenarioDetails] = useState(scenarioOverviewDetails);
  const [variationDetails, setVariationDetails] = useState([]);
  const query = new URLSearchParams(window.location.search);
  const isReportingMode = query.get("mode") === 'reporting';  
  const currentSelectionValue = mapFilterByKey[selectedValue];
  console.log("scenarioOverviewDetails", scenarioOverviewDetails);

  useEffect(() => {
    setSelectedValue(scrollingFilter)
    const newDetails = filterData(scenarioOverviewDetails, mapFilterByKey[scrollingFilter], isFctw)

    setScenarioDetails(newDetails)
  }, [scrollingFilter,scenarioOverviewDetails, isFctw ])

  const columns = [
    {
      header: "Scenario",
      accessorKey: "summary.logical_uuid",
    },
    {
      header: currentSelectionValue === "total_variations" ? (
        <Typography
          style={{
            fontWeight: "bold",
            fontSize: "1.2rem",
            WebkitTextStroke: "0.3px black",
          }}
        >
          Total
        </Typography>
      ) : "Total",
      accessorKey: "summary.mandatory_target.total_variations",
       cell: ({ getValue }) => (
            <Typography
              style={currentSelectionValue === "total_variations" ?{
                fontWeight: "bold",
                fontSize: "1.2rem",
                WebkitTextStroke: "0.3px black"
              }:{}}
            >
              {getValue()}
            </Typography>
          )
    },
    {
      header: "Mandatory Targets",
      columns: [
        {
          header: currentSelectionValue === "passed" ? (
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: "1.2rem",
                WebkitTextStroke: "0.3px black",
              }}
            >
              Pass
            </Typography>
          ) : "Pass",
          accessorKey: "summary.mandatory_target.passed",
          cell: ({ getValue }) => (
            <Typography
              style={currentSelectionValue === "passed" ?{
                fontWeight: "bold",
                fontSize: "1.2rem",
                WebkitTextStroke: "0.3px black"
              }:{}}
            >
              {getValue()}
            </Typography>
          )
        },
        {
          header: currentSelectionValue === "failed" ? (
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: "1.2rem",
                WebkitTextStroke: "0.3px black",
              }}
            >
              Fail
            </Typography>
          ) : "Fail",
          accessorKey: "summary.mandatory_target.failed",
          cell: ({ getValue }) => (
            <Typography
              style={currentSelectionValue === "failed" ?{
                fontWeight: "bold",
                fontSize: "1.2rem",
                WebkitTextStroke: "0.3px black"
              }:{}}
            >
              {getValue()}
            </Typography>
          )
        },
        {
          header: currentSelectionValue === "error" ? (
            <Typography
              style={{
                fontWeight: "bold",
                fontSize: "1.2rem",
                WebkitTextStroke: "0.3px black",
              }}
            >
              Error
            </Typography>
          ) : "Error",
          accessorKey: "summary.mandatory_target.error",
          cell: ({ getValue }) => (
            <Typography
              style={currentSelectionValue === "error" ?{
                fontWeight: "bold",
                fontSize: "1.2rem",
                WebkitTextStroke: "0.3px black"
              }:{}}
            >
              {getValue()}
            </Typography>
          )
        },
        {
          header: "Pass Percentage",
          accessorKey: "summary.mandatory_target.pass_percentage",
        },
      ],
    },
    ...(!isFctw? [
      {
        header: "Development Targets",
        columns: [
          {
            header: currentSelectionValue === "passed" ? (
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  WebkitTextStroke: "0.3px black",
                }}
              >
                Pass
              </Typography>
            ) : "Pass",
            accessorKey: "summary.development_target.passed",
            cell: ({ getValue }) => (
              <Typography
                style={currentSelectionValue === "passed" ?{
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  WebkitTextStroke: "0.3px black"
                }:{}}
              >
                {getValue()}
              </Typography>
            )
          },
          {
            header: currentSelectionValue === "failed" ? (
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  WebkitTextStroke: "0.3px black",
                }}
              >
                Fail
              </Typography>
            ) : "Fail",
            accessorKey: "summary.development_target.failed",
            cell: ({ getValue }) => (
              <Typography
                style={currentSelectionValue === "failed" ?{
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  WebkitTextStroke: "0.3px black"
                }:{}}
              >
                {getValue()}
              </Typography>
            )
          },
          {
            header: currentSelectionValue === "error" ? (
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  WebkitTextStroke: "0.3px black",
                }}
              >
                Error
              </Typography>
            ) : "Error",
            
            accessorKey: "summary.development_target.error",
            cell: ({ getValue }) => (
              <Typography
                style={currentSelectionValue === "error" ?{
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  WebkitTextStroke: "0.3px black"
                }:{}}
              >
                {getValue()}
              </Typography>
            )
          },
          {
            header: "Pass Percentage",
            accessorKey: "summary.development_target.pass_percentage",
          },
        ],
      },
    ] : [])
  ];

  const table = useReactTable({
    data: scenarioDetails,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  const handleScenarioClickForVariations = async (row) => {
    console.log("row clicked for variation details", row);

    let body = {
      logical_uuid: row.original.summary.logical_uuid,
      reporting_level: row.original.reporting_level
    }

    if(row.original.reporting_level==="execution_id"){
      body = {
        ...body,
        execution_id: row.original.execution_id
      } 
    }
    else{
      body = {
        ...body,
        test_run_id: row.original.test_run_id,

      }
    }
    let apiUrl;
    if (page==="closed_loop") apiUrl ="/cm/reporting/fetch-scenario-variation-details";
    else {
      if (isReportingMode) {
        apiUrl = "/cm/reporting-mode/reporting/fetch-scenario-variation-details";
        body = {
          cad_topology_job_uuid: row.original.cad_topology_job_uuid,
          logical_uuid: row.original.summary.logical_uuid
        };
      } else apiUrl = "/cm/open_loop_pg/reporting/fetch-scenario-variation-details";
    }
    const variationDetails = await axios.post(
      apiUrl,
      body
    );
    console.log("Variation details received", variationDetails.data);
    handleClickForVariation(variationDetails.data);
  };

  const handleChange = (event) => {
    const value = event.target.value
    setSelectedValue(value);
    const newDetails = filterData(scenarioOverviewDetails, mapFilterByKey[value], isFctw)
    setScenarioDetails(newDetails)
  };

  // const handleClear = () => {
  //   setSelectedValue(null);
  // };

  return (
    <div>
      <div>
          <FormControl>
          <RadioGroup row value={selectedValue || ""} onChange={handleChange}>
            {["Total", "Passed", "Failed", "Reporting Error"].map((option) => (
              <FormControlLabel key={option} value={option} control={<Radio />} label={option === "Total"?"Total Execution":option} />
            ))}
          </RadioGroup>
          {/* <Box sx={{ marginTop: 1 }}>
            <Button variant="outlined" onClick={handleClear} disabled={!selectedValue}>
              Clear
            </Button>
          </Box> */}
        </FormControl>
      </div>
      <div style={{width: "100%" , maxHeight: "calc(100vh - 265px)", overflow:"auto"}}>
      <table
        style={{
          border: "solid 1px rgba(0,0,0,5)",
          width: "100%",
          borderRadius: "50px",
        }}
      >
        <thead
        style={{
          position: "sticky",
          top: "0"
        }}
        >
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <th
                    key={header.id}
                    colSpan={header.colSpan}
                    style={{
                      position: "sticky",
                      top: "0",
                      borderBottom: "solid 3px rgba(0,0,0,5)",
                      background: "#B0FF45",
                      color: "rgba(0,0,0,1)",
                      fontWeight: "bold",
                      textAlign: "center",
                      padding: "20px",
                      zIndex: 10,
                      borderRight: "1px solid rgba(0,0,0,5)",
                    }}
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr
              key={row.id}
              style={{ padding: "10px" }}
            >
              {row.getVisibleCells().map((cell) => (
                <td
                  key={cell.id}
                  style={{
                    padding: "10px",
                    border: "solid 1px gray",
                    textAlign: "center",
                    cursor: flexRender(cell.column.columnDef.cell, cell.getContext()).props.column.columnDef.header === 'Scenario' && 'pointer',
                    color: flexRender(cell.column.columnDef.cell, cell.getContext()).props.column.columnDef.header === 'Scenario' && '#0056b3', 
                  }}
                  onClick={() =>
                    // onRowClicked(row.original.variations, row.original.Logical_uuid)
                    flexRender(cell.column.columnDef.cell, cell.getContext()).props.column.columnDef.header === 'Scenario' && handleScenarioClickForVariations(row)
                  }
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
    
  );
};

export default ScenarioOverview;
